export const MODAL_FIXED_HEIGHT_VAR = '--modal-fixed-height';
export const MODAL_DEFAULT_HEIGHT = 640;

// Centered modals are never pinned to the top: Fit and Fixed keep at least 48px above and
// below, Tall keeps 10% (80dvh). 640px (or the fixed height) is a limit, the viewport is the other.
// Written out as literals: Tailwind only generates classes it can see verbatim in the source.
const HEIGHTS = {
  fit: 'max-h-[min(640px,calc(100dvh-96px))]',
  tall: 'max-h-[80dvh]',
  fixed: 'h-[min(var(--modal-fixed-height,640px),calc(100dvh-96px))]'
};

export function MODAL_HEIGHT_STYLE({
  isCentered,
  isHeightFixed,
  fixedHeight = MODAL_DEFAULT_HEIGHT
}) {
  // The fixed height goes through a CSS variable so the Tailwind class stays static.
  return isCentered && isHeightFixed ? { [MODAL_FIXED_HEIGHT_VAR]: `${fixedHeight}px` } : {};
}

export default function MODAL_HEIGHT({ isHeightTall = false, isHeightFixed = false } = {}) {
  if (isHeightFixed) return HEIGHTS.fixed;
  if (isHeightTall) return HEIGHTS.tall;
  return HEIGHTS.fit;
}
